import * as React from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { RouteAnnouncer } from '@/components/common/RouteAnnouncer';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { SkipLink } from '@/components/common/Accessibility';
import { CommandPalette } from '@/components/commands/CommandPalette';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <TooltipProvider delayDuration={150}>
          <SkipLink />
          <Outlet />
          <CommandPalette />
          <RouteAnnouncer />
          <Toaster
            richColors
            closeButton
            position="top-right"
            toastOptions={{
              duration: 4000,
              className: 'font-sans',
            }}
          />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
